




































import Vue from "vue";
import {Component} from "vue-property-decorator";
@Component({
    components: {},
    props: {
        preset: {
            type: Object,
            required: true
        }
    }
})

export default class GameCard extends Vue {
    private selectPreset(): void
    {
        this.$emit('select-preset');
    }
}
